import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1] as const;

const LifestyleOpening = () => {
  const { t } = useLanguage();

  return (
    <section className="py-32 md:py-44 lg:py-56 bg-background">
      <div className="container-luxury max-w-2xl text-center">
        <motion.span
          className="font-label text-bronze text-[10px] tracking-[0.35em] block mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, ease }}
        >
          Arzani Lifestyle
        </motion.span>

        <motion.p
          className="font-accent text-foreground/80 text-xl md:text-2xl lg:text-[28px] leading-[1.7] italic mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.15, ease }}
        >
          {t(
            "A destination is not defined by where you stay, but by how your time unfolds.",
            "Een bestemming wordt niet bepaald door waar u verblijft, maar door hoe uw tijd zich ontvouwt."
          )}
        </motion.p>

        <motion.div
          className="w-10 h-px bg-bronze/40 mx-auto mb-10"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.3, ease }}
        />

        <motion.p
          className="font-body text-muted-foreground text-sm md:text-base leading-[2] mb-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.4, ease }}
        >
          {t(
            "Through Arzani Lifestyle, every detail is arranged in advance — allowing you to move through your experience without interruption. From the moment you arrive, everything is aligned with your pace, your preferences, and your way of living.",
            "Via Arzani Lifestyle wordt elk detail vooraf geregeld — zodat u uw ervaring zonder onderbreking kunt beleven. Vanaf het moment dat u aankomt, is alles afgestemd op uw tempo, uw voorkeuren en uw manier van leven."
          )}
        </motion.p>

        <motion.p
          className="font-display text-foreground/60 text-lg md:text-xl tracking-wide leading-[1.8]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.6, ease }}
        >
          {t("What remains is ease.", "Wat overblijft is gemak.")}
          <br />{t("Clarity.", "Helderheid.")}
          <br />{t("Time.", "Tijd.")}
        </motion.p>
      </div>
    </section>
  );
};

export default LifestyleOpening;
